<template>
  <div class="game-container" @mouseup="checkLetter">
    <table>
      <tr v-for="(row, i) in diagram" :key="'row_' + i">
        <td
          v-for="(col, j) in row"
          :key="'col_' + j"
          @mouseover="selectLetter"
          @mousedown="checkLetter"
          @mouseup="checkLetter"
          @touchstart="touchLetter"
          @touchend="touchLetter"
          @touchmove="touchLetter"
          :id="i + '-' + j + '-' + diagram[i][j].letter"
          :ref="i + '-' + j + '-' + diagram[i][j].letter"
          :style="{ background: diagram[i][j].bgr }"
        >
          {{ diagram[i][j].letter }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'mp-find-words',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      startData: {},
      diagram: [],
      selectLetters: false,
      checkWord: [],
      checking: '',
      solved: [],
    };
  },
  beforeMount() {
    this.newGame();
  },
  mounted() {},
  methods: {
    newGame() {
      this.selectLetters = false;
      this.startData = this.startGameConfig.sample[0];
      this.diagram = [];
      this.checkWord = [];
      this.checking = '';
      this.solved = [];
      for (let i = 0; i < this.startData.diag.length; i++) {
        this.diagram[i] = [];
        for (let j = 0; j < this.startData.diag[i].length; j++) {
          this.diagram[i][j] = this.startData.diag[i][j];
          this.diagram[i][j] = {
            letter: this.startData.diag[i][j],
            bgr: this.startGameConfig.colors.bgr,
          };
        }
      }
    },
    resetGameAction() {
      this.newGame();
      for (let i = 0; i < this.startData.diag.length; i++) {
        for (let j = 0; j < this.startData.diag[i].length; j++) {
          let id = i + '-' + j + '-' + this.startData.diag[i][j];
          this.$refs[id][0].style.backgroundColor = this.startGameConfig.colors.bgr;
        }
      }
    },
    checkGameAction() {
      return this.solved.length === this.startData.correct.length;
    },
    selectLetter(a) {
      if (this.selectLetters && a.target.id) {
        let d = a.target.id.split('-');
        let c = [parseInt(d[0]), parseInt(d[1])];
        var flg = false;
        for (let i = 0; i < this.checkWord.length; i++) {
          if (JSON.stringify(this.checkWord[i]) == JSON.stringify(c)) {
            flg = true;
            break;
          }
        }
        if (!flg) {
          this.$refs[a.target.id][0].style.backgroundColor = this.startGameConfig.colors.sel;
          this.checkWord.push([parseInt(d[0]), parseInt(d[1])]);
        }
      }
    },
    touchLetter(a) {
      a.preventDefault();
      var td = document.elementFromPoint(a.changedTouches[0].pageX, a.changedTouches[0].pageY);
      if (td.id) {
        if (a.type == 'touchstart') this.selectLetters = true;
        if (this.selectLetters) {
          td = document.elementFromPoint(a.changedTouches[0].pageX, a.changedTouches[0].pageY);
          this.selectLetter({ target: { id: td.id } });
        }
      }
      if (a.type == 'touchend') {
        this.selectLetters = false;
        this.checkWords();
      }
    },
    checkLetter(a) {
      a.preventDefault();
      if (this.checking == a.type) return;
      this.checking = a.type;
      if (this.selectLetters) {
        this.selectLetters = false;
        this.checkWords();
      } else {
        this.selectLetters = true;
        this.selectLetter(a);
      }
    },
    checkWords() {
      var isCorrect = false;
      for (let i = 0; i < this.startData.correct.length; i++) {
        if (this.solved.indexOf(i) === -1) {
          if (JSON.stringify(this.checkWord) == JSON.stringify(this.startData.correct[i].cord)) {
            this.coloringWord(this.startData.correct[i].color);
            isCorrect = true;
            this.solved.push(i);
            break;
          }
        }
      }
      if (this.solved.length === this.startData.correct.length) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
      if (!isCorrect) this.coloringWord(this.startGameConfig.colors.bgr);
      this.checkWord = [];
    },
    coloringWord(color) {
      for (let i = 0; i < this.checkWord.length; i++) {
        let id =
          this.checkWord[i][0] +
          '-' +
          this.checkWord[i][1] +
          '-' +
          this.diagram[this.checkWord[i][0]][this.checkWord[i][1]].letter;
        if (color !== this.startGameConfig.colors.sel && color !== this.startGameConfig.colors.bgr) {
          this.diagram[this.checkWord[i][0]][this.checkWord[i][1]].bgr = color;
        }
        if (
          color == this.startGameConfig.colors.bgr &&
          this.diagram[this.checkWord[i][0]][this.checkWord[i][1]].bgr != this.startGameConfig.colors.sel
        ) {
          this.$refs[id][0].style.backgroundColor = this.diagram[this.checkWord[i][0]][this.checkWord[i][1]].bgr;
        } else {
          this.$refs[id][0].style.backgroundColor = color;
        }
      }
    },
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function(newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      // console.log('newStatus', newStatus);
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.game-container {
  display: flex;
  padding-top: 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.game-container table {
  border-collapse: collapse;
  font-weight: bold;
}

.game-container td {
  border: 1px solid black;
  vertical-align: central;
  text-align: center;
  padding: 0.25em 0.5em;
}
</style>
